<div class="board-container-battle" *ngIf="(challenge?.IsRunning || challenge?.ChallengeRewarded) && challenge?.Rankings.length == 2" #BoardShipContainer>
  <ng-template *ngIf="challenge?.ChallengeID && player.GameStatus > 2 then ChallengeEnded else BattleBoatInfo"></ng-template>
  <ng-template #BattleBoatInfo>
    <div class="challenge-running">
      <strong cvLocalizedText langSection="Challenges_Details" langKey="Details">Details:</strong>
      <div class="flex details-container battle-boat-info">
        <div class="battle-boat-data">
          <p>
            <span cvLocalizedText langSection="Challenges" langKey="Wager">Wager: </span>: {{ challenge?.Wager }} 
            <span cvLocalizedText langSection="Gamification_Tabs" langKey="Coins">Coins</span>
          </p>
          <p><span cvLocalizedText langSection="Challenges_Details" langKey="Ends">Ends: </span> {{ challenge?.EndDate_ForView }}</p>
          <p><span cvLocalizedText langSection="Challenges_Details" langKey="Hits">Hits: </span> {{ player?.Hits }}</p>
          <p [ngClass]="{
            'text-error': player?.ShotsAvailable == 0
          }"><span cvLocalizedText langSection="Challenges_Details" langKey="Shots_Remaining">Shots Remaining: </span>: {{ player.ShotsAvailable }}/4</p>
        </div>
        <div class="divider"></div>
        <div class="metric-data">
          <p><span cvLocalizedText langSection="Challenges_Details" langKey="My_Metric_Score">My Metric Score:</span> <span class="metric-value"> {{  getMyRanking() || '---' }}</span></p>
          <p><span cvLocalizedText langSection="Challenges_Details" langKey="Rivals_Metric_Score">Rival's Metric Score:</span> <span class="metric-value"> {{  getRivalRanking() || '---' }}</span></p>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #ChallengeEnded>
    <div class="challenge-ended">
      <strong cvLocalizedText langSection="Challenges_Details" langKey="Details" class="challenge-details">Details:</strong>
      <div class="challenge-ended-info">
        <div>
          <span cvLocalizedText langSection="Challenges" langKey="Wager">Wager</span>:
        </div>
        <span>
          {{ challenge?.Wager }} 
          <span cvLocalizedText langSection="Gamification_Tabs" langKey="Coins">
            Coins
          </span>
        </span>      
      </div>
      <div class="challenge-ended-info">
        <span cvLocalizedText langSection="Challenges_Details" langKey="Ended">Ended: </span>
        <span>{{ challenge?.EndDate_ForView }}</span>
      </div>
      <div class="challenge-ended-info">
        <span cvLocalizedText langSection="Challenges_Details" langKey="My_Metric_Score">My Metric Score:</span>
        <span class="metric-value"> {{  getMyRanking() || '---' }}</span>
      </div>
      <div class="challenge-ended-info">
        <span cvLocalizedText langSection="Challenges_Details" langKey="Rivals_Metric_Score">Rival's Metric Score:</span>
        <span class="metric-value"> {{  getRivalRanking() || '---' }}</span>
      </div>
    </div>  
  </ng-template>
  <div class="btn-shoot-container">
    <span [ngClass]="{
        'battle-boat-tooltip': true,
        'display-tooltip': displayTooltip && !cellMarked && player.GameStatus < 3,
      }"
      cvLocalizedText 
      langSection="Challenges" 
      langKey="select_a_square">Please select a square on the grid in order to shoot.</span>
    <button 
      *ngIf="challenge?.ChallengeID && player.GameStatus < 3" 
      [disabled]="!canShot || !cellMarked || player?.ShotsAvailable == 0 || player?.GameStatus > 2"
      class="btn btn-primary btn-mark-cell btn-shoot" 
      (click)="shotMarkCell()"
      (mouseenter)="toggleTooltip(true)"
      (mouseleave)="toggleTooltip(false)"
      type="button"
      cvLocalizedText 
      langSection="Challenges" 
      langKey="shoot"
      [title]="canShot && !cellMarked ? '': ''">Shoot!</button>
  </div>
  <!-- Board Rows and Columns -->
  <div [ngClass]="{
    placedShips: true,
    board: true,
  }">
    <div *ngFor="let row of board; let i = index" class="board-row">
      <div *ngFor="let cell of row; let j = index" class="board-cell" (click)="onCellClick(i, j)"  [ngStyle]="{
        width: cellSize + 'px',
        height: cellSize + 'px'
      }">
        <div *ngIf="canShot && shots[i][j]?.shot === true" [ngClass]="{
          hit: !!shots[i][j].hit && !isCellInSunkenShip(i, j, sunkenShips),
          shot: true
        }">
          <img class="img-shot" *ngIf="!!shots[i][j].hit" src="../App_Themes/clearview-default/images/challenges/battleboat/shoot-mark.svg" alt="X">
          <img class="img-miss" *ngIf="!shots[i][j].hit" src="../App_Themes/clearview-default/images/challenges/battleboat/miss-mark.svg" alt="-">
        </div>

        <!-- Rival shots -->
        <div *ngIf="!canShot && rivalsShots[i][j]?.shot === true" [ngClass]="{
          hit: !!rivalsShots[i][j].hit && !isCellInSunkenShip(i, j, mySunkenShips),
          shot: true
        }">
          <!-- Hit marker (X) -->
          <img class="img-shot" 
               *ngIf="rivalsShots[i][j].hit" 
               src="../App_Themes/clearview-default/images/challenges/battleboat/shoot-mark.svg" 
               alt="X">
          
          <!-- Miss marker (-) -->
          <div class="rival-miss" 
               *ngIf="!rivalsShots[i][j].hit">
            <img class="img-miss"
                 src="../App_Themes/clearview-default/images/challenges/battleboat/miss-mark.svg" 
                 alt="-">
          </div>
        </div>
        
        <div *ngIf="canShot && shots[i][j]?.mark === true" class="mark-cell">
        </div>
      </div>
    </div>
    <ng-template *ngIf="canShot; then rivalsGrid else myShips"></ng-template>
    <ng-template #myShips>
      <div *ngFor="let ship of mySunkenShips" class="placed-ship sunken-ships" [ngStyle]="getPlacedShipStyle(ship)">
        <div [ngClass]="{
          'boat-overlay': true,
          'orientation-horizontal': ship.orientation != 'vertical',
          'orientation-vertical': ship.orientation == 'vertical'
        }"></div>
      </div>
      <div *ngFor="let ship of placedShips" class="placed-ship" [ngStyle]="getPlacedShipStyle(ship)">
        <img [src]="getShipImageUrl(ship)" [style.width]="'100%'" [style.height]="'100%'" />
      </div>
    </ng-template>
    <ng-template #rivalsGrid>
      <div *ngFor="let ship of sunkenShips" class="placed-ship sunken-ships" [ngStyle]="getPlacedShipStyle(ship)">
        <div [ngClass]="{
          'boat-overlay': true,
          'orientation-horizontal': ship.orientation != 'vertical',
          'orientation-vertical': ship.orientation == 'vertical'
        }"></div>
        <img [src]="getShipImageUrl(ship)" [style.width]="'100%'" [style.height]="'100%'" />
      </div>
    </ng-template>
  </div>
</div>